import { Trophy, ArrowUp, ArrowDown, Minus } from "@phosphor-icons/react";
import { FieldLabel } from "../shared/FieldHint";

function TrendIndicator({ currentRank, previousRank, testId }) {
  if (previousRank == null) return <span className="text-igc-muted text-[10px]" data-testid={testId}>—</span>;
  if (previousRank > currentRank) return <ArrowUp size={14} weight="bold" className="text-igc-success" data-testid={testId} />;
  if (previousRank < currentRank) return <ArrowDown size={14} weight="bold" className="text-igc-danger" data-testid={testId} />;
  return <Minus size={14} weight="bold" className="text-igc-muted" data-testid={testId} />;
}

export function ManagerLeaderboard({ managers }) {
  if (managers.length === 0) return null;
  const ranked = [...managers].sort((a, b) => b.commission.total_earned - a.commission.total_earned);
  const hasEarnings = ranked.some((m) => m.commission.total_earned > 0);

  return (
    <div className="bg-igc-surface border border-igc-gold/15 p-5 mb-8" data-testid="manager-leaderboard">
      <h2 className="font-serif text-xl text-igc-cream tracking-tight mb-4 flex items-center gap-2">
        <Trophy size={18} weight="duotone" className="text-igc-goldText" /> Manager Leaderboard
        <FieldLabel hint="Ranked by total commissions earned. The arrow shows whether each manager moved up, down, or held steady vs. last week." testId="manager-leaderboard-hint" />
      </h2>
      <div className={`grid gap-4 ${ranked.length === 2 ? "md:grid-cols-2" : "md:grid-cols-3"}`}>
        {ranked.map((m, i) => (
          <div key={m.id} className="bg-igc-surfaceLight border border-igc-gold/15 p-4 relative" data-testid={`manager-leaderboard-card-${m.id}`}>
            {i === 0 && hasEarnings && (
              <span className="absolute -top-2 -right-2 text-[10px] px-2 py-1 bg-igc-gold text-black uppercase tracking-wide font-medium" data-testid={`manager-leaderboard-lead-badge-${m.id}`}>
                Leading
              </span>
            )}
            <div className="flex items-center gap-2 mb-3">
              <p className="font-serif text-lg text-igc-cream"><span className="text-igc-goldText">{m.code}</span> — {m.display_name}</p>
              <TrendIndicator currentRank={i + 1} previousRank={m.previous_rank} testId={`manager-leaderboard-trend-${m.id}`} />
            </div>
            <div className="grid grid-cols-3 gap-2 text-center">
              <div>
                <p className="text-igc-cream text-lg" data-testid={`manager-leaderboard-clients-${m.id}`}>{m.clients_referred}</p>
                <FieldLabel hint="Total leads this manager closed into clients." testId={`manager-leaderboard-clients-hint-${m.id}`}>Clients Referred</FieldLabel>
              </div>
              <div>
                <p className="text-igc-success text-lg" data-testid={`manager-leaderboard-commission-${m.id}`}>${m.commission.total_earned.toLocaleString()}</p>
                <FieldLabel hint="Direct commission plus override commission earned to date." testId={`manager-leaderboard-commission-hint-${m.id}`}>Commissions Earned</FieldLabel>
              </div>
              <div>
                <p className="text-igc-cream text-lg" data-testid={`manager-leaderboard-affiliates-${m.id}`}>{m.active_sub_affiliate_count}</p>
                <FieldLabel hint="Affiliates on this manager's team who are currently active." testId={`manager-leaderboard-affiliates-hint-${m.id}`}>Active Affiliates</FieldLabel>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
